'use client';

import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { box } from '@/app/styles/ui';
import { Eligibility } from '@/types/Eligibility';

import { Info } from '../OrderInfo/OrderInfo';

export interface EligibilityDisplayProps {
  readonly className?: string;
  readonly isEligible: Eligibility['isEligible'];
  readonly onSelectEligibility: () => void;
  readonly customer: Eligibility['customer'];
}

const EligibilityDisplay = ({
  className,
  customer,
  isEligible,
  onSelectEligibility,
}: EligibilityDisplayProps) => {
  const t = useTranslations();
  const isDisabled = !isEligible;

  return (
    <div
      data-testid="eligibility-display"
      className={cx(box({ p: 10 }), 'flex flex-col gap-10', className)}
    >
      <div className="flex items-center justify-between">
        <Typography
          data-testid="eligibility-display-status"
          className="rounded bg-black px-3 py-1 uppercase tracking-wider"
          color="light"
          variant="eyebrow-small"
          weight="bold"
        >
          {t('eop_home_orders_page_status_pending')}
        </Typography>

        <Button
          onClick={onSelectEligibility}
          data-testid="eligibility-display-enroll-now-button"
          disabled={isDisabled}
        >
          {t('eop_eligibility_claim_benefit_button')}
        </Button>
      </div>

      <div className={cx(box({ bg: 'gray' }), 'w-full grid gap-4 p-4')}>
        <div className="flex flex-wrap justify-between gap-4 lg:col-span-2 lg:row-start-1">
          <Info
            heading={
              customer?.name ? (
                <span className="flex items-center gap-1.5">
                  {t('eop_eligibility_benefit_from', {
                    name: customer.name,
                  })}
                </span>
              ) : null
            }
          >
            <Typography>{t('eop_eligibility_available_now')}</Typography>
          </Info>
          <Info
            heading={
              <span className="flex items-center gap-1.5">
                {t('eop_order_shippingaddress')}
              </span>
            }
          >
            <Typography>{t('eop_eligibility_address_needed')}</Typography>
          </Info>
        </div>
      </div>
    </div>
  );
};

export default EligibilityDisplay;
